module.exports = __webpack_public_path__ + "img/icon_result-success.779e7ecd.svg";